/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Curated set of commonly used IANA timezone identifiers. Not exhaustive —
 * the runtime accepts any valid IANA zone (validated via `isTimeZone()`,
 * see `Timezone` in `lib/dashboard/decorator/timezone.decorator.ts`).
 * Used as `TimeZoneEnum` so IDEs surface these as autocomplete
 * suggestions without narrowing out legitimate zones outside this list.
 * Mirrors the frontend's `FALLBACK_TIMEZONES` in `lib/utility/timezone-helper.ts`.
 */
export enum TimeZoneEnum {
  utc = "UTC",
  europeBerlin = "Europe/Berlin",
  europeLondon = "Europe/London",
  europeParis = "Europe/Paris",
  europeMadrid = "Europe/Madrid",
  europeRome = "Europe/Rome",
  europeAmsterdam = "Europe/Amsterdam",
  europeBrussels = "Europe/Brussels",
  europeVienna = "Europe/Vienna",
  europeZurich = "Europe/Zurich",
  europeWarsaw = "Europe/Warsaw",
  europePrague = "Europe/Prague",
  europeStockholm = "Europe/Stockholm",
  europeHelsinki = "Europe/Helsinki",
  europeAthens = "Europe/Athens",
  europeIstanbul = "Europe/Istanbul",
  europeMoscow = "Europe/Moscow",
  europeLisbon = "Europe/Lisbon",
  europeDublin = "Europe/Dublin",
  americaNewYork = "America/New_York",
  americaChicago = "America/Chicago",
  americaDenver = "America/Denver",
  americaLosAngeles = "America/Los_Angeles",
  americaToronto = "America/Toronto",
  americaSaoPaulo = "America/Sao_Paulo",
  americaMexicoCity = "America/Mexico_City",
  asiaDubai = "Asia/Dubai",
  asiaKolkata = "Asia/Kolkata",
  asiaShanghai = "Asia/Shanghai",
  asiaHongKong = "Asia/Hong_Kong",
  asiaSingapore = "Asia/Singapore",
  asiaTokyo = "Asia/Tokyo",
  asiaSeoul = "Asia/Seoul",
  asiaJerusalem = "Asia/Jerusalem",
  australiaSydney = "Australia/Sydney",
  australiaPerth = "Australia/Perth",
  pacificAuckland = "Pacific/Auckland",
  africaCairo = "Africa/Cairo",
  africaJohannesburg = "Africa/Johannesburg"
}
